import type { IconProps } from "./icon-types";

/**
 * 채운 삼각형 안 정립 "!" — warning/주의 상태 표시. `WarningIcon`의 채움 변형.
 * 면은 `currentColor`로 채우고 기호는 `text.onStatus`(테마 밖 fallback 흰색)로 얹는다. 선 버전과 같은
 * c6 자체 기하의 채움 변형 — 알림처럼 아이콘이 tone을 전달해야 하는 자리용.
 */
export const WarningFilledIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M8 1.6 15.2 14.2H.8Z" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" />
    <path
      d="M8 6.2v3.3"
      fill="none"
      stroke="var(--c6-color-text-on-status, #ffffff)"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <circle cx="8" cy="11.9" r="1" fill="var(--c6-color-text-on-status, #ffffff)" />
  </svg>
);
